const points = [
	{
		path: 'points',
		name: 'points.index',
		component: () => import('@/views/points/List.vue'),
		meta: { layout: 'content' },
	},
]

export default points
